<div class="block-title">
  <h2 class="block-title__text" translate>Leave your review</h2>
</div>

<form #f="ngForm" [formGroup]="addReviewForm">
  <div class="row">
    <div class="col-md-12">
      <app-speedy-input
        placeholder="Name"
        formControlName="nickname"
        name="nickname"
        type="text"
        [fontSize]="14"
        [control]="addReviewForm.controls.nickname"
      ></app-speedy-input>
    </div>
    <div class="col-md-12">
      <app-speedy-input
        placeholder="Email address or phone number"
        formControlName="title"
        name="title"
        type="text"
        [fontSize]="14"
        [control]="addReviewForm.controls.title"
      ></app-speedy-input>
    </div>
    <div class="col-md-12" formArrayName="ratings">
      @for (rating of addReviewForm.controls.ratings.controls; track $index) {
        <ng-container [formGroupName]="$index">
          <star-rating-control
            labelPosition="top"
            [rating]="rating.controls.value.value!"
            [formControl]="rating.controls.value"
          ></star-rating-control>
        </ng-container>
      }
    </div>
    <div class="col-md-12">
      <app-speedy-textarea
        placeholder="Comment"
        formControlName="detail"
        name="detail"
        [fontSize]="14"
        [control]="addReviewForm.controls.detail"
      ></app-speedy-textarea>
    </div>
    <div class="col-sm-12">
      <app-speedy-button
        [loading]="(loading$ | async)!"
        [text]="'Save'"
        (clicked)="submit()"
      ></app-speedy-button>
    </div>
  </div>
</form>
